<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-22 17:57:45
 * @LastEditors: 
 * @LastEditTime:
 * @FilePath: 
 * @Description: 订单提交成功页面
-->
<template>
  <div class="customerBindingHandResult">
    <div class="statusIcon">
      <img
        class="full_img"
        src="@/assets/images/customerBindHandSuccess.png"
        alt=""
      />
    </div>
    <div class="successTxt">
      <p>点菜成功</p>
      <p>美味制作中</p>
    </div>
    <div class="m-tb-80">
      <van-button color="#00CCCC" round block @click="handleToDetail"
        >查看消费明细</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    handleToDetail() {
      this.$router.replace("MicropointHistoryConsume");
    },
  },
};
</script>

<style lang="scss" scoped>
.customerBindingHandResult {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding: 0 32px;
  box-sizing: border-box;

  .statusIcon {
    width: 372px;
    height: 372px;
    margin: 0 auto 60px;
    padding-top: 115px;
  }
  .successTxt {
    text-align: center;
    > p:first-child {
      // margin-bottom: 20px;
      font-size: 30px;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      line-height: 42px;
    }
    > p:nth-child(2) {
      font-size: 40px;
      font-weight: 400;
      line-height: 80px;
      color: #00cccc;
    }
  }
}
</style>
